var map = {
	"./en.json": "ZpMc",
	"./fr.json": "kKqp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z4cC";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/reports [A-Za-z0-9-_,\s]+\.json$/
// module id = z4cC
// module chunks = 1